import { useXAxisContext } from 'utils/components/TimeSeriesChart/XAxisContext';
import { useHorizontalZoomContext } from 'utils/components/Zoom/ZoomContext';
import { useEffect } from 'react';

export function useXAxisLabelTimeLine(
    boxLeft: number | undefined,
    time: number,
    isHovering: boolean,
    className: string
) {
    const xAxisContext = useXAxisContext();
    const { timePointerRef } = xAxisContext;
    const { publish } = timePointerRef.current;
    const { zoomedXScale: xScale } = useHorizontalZoomContext();

    useEffect(() => {
        const x = xScale(time);
        if (isHovering) {
            publish({ x, time, className });
        } else {
            publish({ x: undefined, time: undefined });
        }
    }, [isHovering, time, className, publish, xScale]);
}
